import React, { useState } from "react";
import { Row, Col, Card, Space, Typography, Form, Input, Button, Layout, Divider, message } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { IMAGES } from "../../constants/images";
import { useAuth } from "../../contexts/AuthContext";
import { validateCPF } from "../../helpers/validators";
import InputMask from "../../components/inputMask";
import { useNavigate } from "react-router-dom";
import { handleLogin } from "../../api/autenticacao";
const { Text, Link, Title } = Typography;

const styles = {
  row: {
    flexGrow: 1,
  },
};

const validator = {
  cpf: [
    { required: true, message: "Informe o CPF!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || validateCPF(getFieldValue("cpf"))) {
          return Promise.resolve();
        }
        return Promise.reject("Informe um CPF válido!");
      },
    }),
  ],
  senha: [{ required: true, message: "Informe a senha!" }],
};

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { iniciarSessao } = useAuth();

  const realizarLogin = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await handleLogin(formulario);
      if (retorno?.statusCode === 200) {
        await iniciarSessao({
          logado: true,
          usuario: retorno?.response?.data?.usuario,
          token: retorno?.response?.data?.access_token,
        });

        navigate("/");
      } else {
        form.setFieldValue("senha", "");
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    realizarLogin({
      cpf: formulario?.cpf?.replace(/[^\d]+/g, ""),
      senha: formulario?.senha,
    });
  };

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card title={<img src={IMAGES?.curriculos} height={80} width="100%" className="resize-contain" />}>
          <Space direction="vertical" className="full-width" size={20}>
            <Title strong className="title" align="center">
              Login
            </Title>

            <Form form={form} layout="vertical" autoComplete="off" onFinish={onSubmit}>
              <Form.Item name="cpf" label="CPF" hasFeedback rules={validator?.cpf}>
                <InputMask mask="999.999.999-99" size="large" placeholder="Informe o CPF" disabled={loading} />
              </Form.Item>

              <Form.Item name="senha" label="Senha" hasFeedback rules={validator?.senha}>
                <Input.Password
                  size="large"
                  placeholder="Informe a senha"
                  disabled={loading}
                  iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>

              <Layout.Content align="right" style={{ marginBottom: 10 }}>
                <Link type="link" onClick={() => navigate("/recuperacao-senha")} style={{ align: "right" }}>
                  Esqueceu sua senha?
                </Link>
              </Layout.Content>

              <Form.Item className="FormItem">
                <Button size="large" type="primary" className="full-width" loading={loading} htmlType="submit">
                  Entrar
                </Button>
              </Form.Item>

              <Form.Item className="FormItem">
                <Button
                  size="large"
                  onClick={() => navigate("/")}
                  loading={loading}
                  type="dashed"
                  className="full-width">
                  Cadastro
                </Button>
              </Form.Item>
            </Form>
          </Space>
          <Divider />

          <Layout.Content style={{ textAlign: "center" }}>
            <Text disabled>DPTO TI - COPÉRDIA &copy;</Text>
          </Layout.Content>
        </Card>
      </Col>
    </Row>
  );
};

export default Login;
